import type { Compromisso } from '../db/tipos'
import { dataISOLocal } from '../pedidos/precos'

// ▶ Aviso com antecedencia (pedido dela 08/10). Decisoes: D1 (a) so com o app
// aberto -- notificacao com o app fechado e outro ciclo; D2 coluna nova
// `aviso_minutos` (0034); D3 opcoes abaixo, 15 min ja marcado ao criar.
// A janela vai do inicio do aviso ate a HORA do compromisso; dali em diante
// quem avisa e a janela vermelha de atrasado (regras.ts).

export const OPCOES_AVISO: ReadonlyArray<{ minutos: number | null; rotulo: string }> = [
  { minutos: null, rotulo: 'Sem aviso' },
  { minutos: 10, rotulo: '10 min antes' },
  { minutos: 15, rotulo: '15 min antes' },
  { minutos: 30, rotulo: '30 min antes' },
  { minutos: 60, rotulo: '1 hora antes' },
  { minutos: 1440, rotulo: '1 dia antes' },
]

export const AVISO_PADRAO = 15

export function avisoValido(minutos: number | null): boolean {
  return OPCOES_AVISO.some((o) => o.minutos === minutos)
}

function inicioDe(c: Compromisso): Date {
  const [a, m, d] = c.data.split('-').map(Number)
  const [h, min] = c.hora.split(':').map(Number)
  return new Date(a, m - 1, d, h, min)
}

export function avisosAgora(lista: readonly Compromisso[], agora: Date): Compromisso[] {
  const ms = agora.getTime()
  return lista
    .filter((c) => {
      // `== null` pega o null e o undefined do aparelho que ainda nao tem o campo.
      if (c.apagado_em !== null || c.situacao !== 'pendente' || c.aviso_minutos == null) return false
      const inicio = inicioDe(c).getTime()
      return ms >= inicio - c.aviso_minutos * 60_000 && ms < inicio
    })
    .sort((a, b) => inicioDe(a).getTime() - inicioDe(b).getTime())
}

// O "ja avisei" e por aparelho. A chave inclui data, hora e antecedencia: se
// ela remarcar o compromisso, o aviso volta a valer.
export function chaveDoAviso(c: Compromisso): string {
  return `${c.id}|${c.data}|${c.hora}|${c.aviso_minutos ?? ''}`
}

export function textoDoFaltam(c: Compromisso, agora: Date): string {
  if (c.data !== dataISOLocal(agora)) return `Amanhã às ${c.hora}`
  const minutos = Math.max(1, Math.ceil((inicioDe(c).getTime() - agora.getTime()) / 60_000))
  if (minutos < 60) return `Começa em ${minutos} min`
  const horas = Math.floor(minutos / 60)
  const resto = minutos % 60
  if (resto === 0) return `Começa em ${horas} ${horas === 1 ? 'hora' : 'horas'}`
  return `Começa em ${horas}h${String(resto).padStart(2, '0')}`
}
